import React from 'react';
import EntityManagementPage, { EntityField } from './EntityManagementPage';
import { useAppSelector } from '../../store/hooks';
import {
  createAdditionalService,
  deleteAdditionalService,
  fetchAdditionalServices,
  updateAdditionalService,
} from '../../store/slices/eventOrderSlice';
import { AdditionalService } from '../../types';

const fields: EntityField[] = [
  { key: 'name', label: 'Назва послуги', required: true },
  { key: 'price', label: 'Ціна продажу', type: 'number', required: true },
  { key: 'costPrice', label: 'Типова собівартість', type: 'number', required: true },
  { key: 'description', label: 'Опис', type: 'textarea' },
];

const AdditionalServicesPage: React.FC = () => {
  const state = useAppSelector((s) => s.eventOrder);
  return (
    <EntityManagementPage<AdditionalService>
      title="Управління додатковими послугами"
      items={state.additionalServices}
      loading={state.loading}
      submitting={false}
      error={null}
      fields={fields}
      fetchAll={fetchAdditionalServices}
      createItem={createAdditionalService}
      updateItem={updateAdditionalService}
      deleteItem={deleteAdditionalService}
    />
  );
};

export default AdditionalServicesPage;
